// extracted by mini-css-extract-plugin
export default {"main":"SmallImage_main__sUUz4","img":"SmallImage_img__XopHM"};